import { render, staticRenderFns } from "./SupportEmail.vue?vue&type=template&id=7b01ac96&scoped=true"
import script from "./SupportEmail.vue?vue&type=script&lang=js"
export * from "./SupportEmail.vue?vue&type=script&lang=js"
import style0 from "./SupportEmail.vue?vue&type=style&index=0&id=7b01ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b01ac96",
  null
  
)

export default component.exports